export const CFG = {
  breakpoint: 768,
};

// Google Maps API キー（本番用）。ローカル等で WordPress が data-js="map-config" を出力した場合はそちらを優先
const PRODUCTION_GOOGLE_MAPS_API_KEY = 'AIzaSyBSywbjW8XqvqPH722huxeXbaxeXLz-CNY';

const loadMapConfig = () => {
  const el = document.querySelector('[data-js="map-config"]');
  if (!el) return {};
  try {
    return JSON.parse(el.textContent) || {};
  } catch (e) {
    console.error('map-config JSON の解析に失敗しました', e);
    return {};
  }
};

export const GOOGLE_MAPS_API_KEY = loadMapConfig().apiKey || PRODUCTION_GOOGLE_MAPS_API_KEY;
